import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { useCallback, useState } from 'react';
import Draggable from 'react-draggable';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { UserRolePermissions } from '../../constants';
import { checkSitePermission } from '../../store/slices/user';
import ContactAdvisorEmailModal from './ContactAdvisorEmailModal';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    fontFamily: 'var(--fontFamilyBody)',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[0],
    fontSize: 14,
    padding: 12,
    maxWidth: '260px',
  },
  arrow: {
    color: theme.palette.common.white,
  },
}))(Tooltip);

const ContactAdvisor = () => {
  const { travelAgency } = useSelector((store) => store.user);
  const [doShowToolTip, setDoShowToolTip] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const canRequestAdvisor = useSelector(checkSitePermission(UserRolePermissions.canRequestAdvisor));

  const handleCloseTooltip = (e) => {
    if (e) e.stopPropagation(); // prevent from opening advisor email modal.
    setDoShowToolTip(false);
  };

  const handleOpenTooltip = () => {
    setDoShowToolTip(true);
  };

  const handleClick = useCallback(() => {
    if (isDragging) return; // Don't open modal on click if click was intended for dragging.
    setIsModelOpen((v) => !v);
    handleCloseTooltip();
  }, [isDragging]);

  const eventControl = useCallback(
    (eventType) => {
      if (eventType === 'touchend' && !isDragging) {
        handleClick(); // fix issue On mobile devices of modal not opening on click.
        return;
      }
      if (eventType === 'mousemove' || eventType === 'touchmove') {
        setIsDragging(true);
      }
      if (eventType === 'mouseup' || eventType === 'touchend') {
        setTimeout(() => {
          setIsDragging(false);
        }, 100); // set dragging to false with threshold. To differ from click vs drag/drop.
      }
    },
    [handleClick, isDragging],
  );

  if (!travelAgency || !canRequestAdvisor) return <></>;

  return (
    <>
      <ContactAdvisorEmailModal isModalOpen={isModelOpen} handleCloseModal={handleClick} />
      <div className="w-screen h-screen overflow-hidden fixed z-20">
        <Draggable
          bounds="parent"
          onDrag={(e) => {
            eventControl(e.type);
          }}
          onStop={(e) => {
            eventControl(e.type);
          }}
        >
          <div
            className="fixed right-0 bottom-0 align-middle overflow-hidden m-5"
            style={{ borderRadius: '50%' }}
            onClick={handleClick}
            onMouseEnter={handleOpenTooltip}
            onMouseOut={(e) => {
              handleCloseTooltip(e);
            }}
            onBlur={() => {}}
            role="presentation"
          >
            <LightTooltip
              title={
                <div className="flex gap-2 z-50">
                  <div>
                    {travelAgency &&
                    travelAgency.settings &&
                    travelAgency.settings.contactAdvisorTooltipText
                      ? travelAgency.settings.contactAdvisorTooltipText
                      : 'Contact our advisor to help you with this trip.'}
                  </div>
                  <AiFillCloseCircle
                    className="text-2xl cursor-pointer"
                    onClick={(e) => {
                      handleCloseTooltip(e);
                    }}
                  />
                </div>
              }
              open={doShowToolTip}
              arrow
              interactive
              placement="top"
            >
              <div className="w-max cursor-grab">
                <img
                  src={travelAgency.advisorImage}
                  alt="Contact advisor"
                  style={{ boxShadow: '0 0 12px 0 rgb(0 0 0 / 50%)' }}
                  className="align-middle h-20 w-20 rounded-full pointer-events-none"
                />
              </div>
            </LightTooltip>
          </div>
        </Draggable>
      </div>
    </>
  );
};

export default ContactAdvisor;
